import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-barrios',
  templateUrl: './barrios.component.html',
  styleUrls: ['./barrios.component.scss'],
  providers: [CommonService]
})
export class BarriosComponent implements OnInit {
  public ciudades:any[];
  public selectedCiudad:number;
  public zonasByCiudad:any[];
  public zonas:any[];
  public barrios:any[];
  public barrio:any;

  constructor(private commonService:CommonService) { }

  ngOnInit() {
    this.selectedCiudad = 0;

    this.barrio = {
      zonas_id: 0,
      nombre: ''
    };

    Promise.all([
      this.commonService.getCiudades(),
      this.commonService.getZonas(),
      this.commonService.getBarriosZonaCiudad()
    ]).then(result => { 
      this.ciudades = result[0]
      this.zonas = result[1];
      this.barrios = result[2];
    });
  }

  public getNombreZona(idZona):string {
    let result = '';

    this.zonas.forEach(zona => {
      if (zona.id === idZona) {
        result = zona.nombre;
      }
    });

    return result;
  }

  public saveBarrio() {
    this.commonService
      .saveBarrio(this.barrio)
      .then(() => {
        this.barrio = {
          zonas_id: 0,
          nombre: ''
        };
        this.commonService.getBarriosZonaCiudad()
          .then(result => this.barrios = result);
    });
  }

  public getZonasByCiudad():void {
    this.barrio.zonas_id = 0;
    this.commonService.getZonasXCiudad(this.selectedCiudad)
      .then(result => this.zonasByCiudad = result);
  }
}



// WEBPACK FOOTER //
// /Users/tretapey/Documents/Programmer/craCSS/DOC-in/src/app/carga/barrios/barrios.component.ts